
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|5750|5826|8488)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
